import React, { Fragment } from "react";
import styled from "styled-components";
import baseStyles from "../../styles/baseStyles";
import ButtonComponent from "../UI/Button";
import ReactMarkdown from "react-markdown";
import { navigateTo } from "gatsby-link";

const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Country = styled.h2`
  transition: 0.3s all ease-in;
  font-family: Lato;
  font-size: 1.25rem;
  color: ${baseStyles.color.gray};
  letter-spacing: 1.2px;
  text-transform: uppercase;
  font-weight: 600;
  margin: 0 0 0 0.5rem;
  padding: 0;
`;

const Flag = styled.img`
  height: 1.5rem;
`;

const Description = styled(ReactMarkdown)`
  overflow-y: auto;
  font-family: Lato;
  font-size: 1rem;
  color: rgba(37, 42, 43, 0.75);
  text-align: left;
`;

const InfoCard = ({ url, name, description }) => {
  return (
    <Fragment>
      <Title>
        <Flag src={url} alt={name} />
        <Country>{name}</Country>
      </Title>
      <Description source={description} />
      <ButtonComponent
        style={{ marginTop: "auto" }}
        primary
        onClick={() => navigateTo(`/nordics/${name.toLowerCase()}`)}
      >
        Learn more
      </ButtonComponent>
    </Fragment>
  );
};

export default InfoCard;



// WEBPACK FOOTER //
// ./src/components/InfoCardCarousel/InfoCard.js